export function productsUrl(product: any, lang?: string): string {
    // translatePrefix se koristi zbog prethodnog koriscenja useTranslations() hook-a na 2 mesta = fatal error
    const prefix = translatePrefix(lang, {en: 'products', sr: 'proizvodi'});
    return `${lang !== process.env.NEXT_PUBLIC_DEFAULT_LANG ? ('/' + lang) : ''}/${prefix}/${product.id}/${product.call_to_action_catalog_product.seo_slug}`;
}

export function newsUrl(news: any, lang?: string): string {
    const prefix = translatePrefix(lang, {en: 'news', sr: 'vesti'});
    return `${lang !== process.env.NEXT_PUBLIC_DEFAULT_LANG ? ('/' + lang) : ''}/${prefix}/${news.id}/${news.seo_slug}`;
}


export function isNewsPage(model: any): model is any{
    return typeof model === 'object' && model !== null && model.hasOwnProperty('created_by');
}


export function isExternalUrl(url: string | undefined): boolean {
    if (!url) {
        return false;
    }
    if (!url.match(/\:\/\//)) {
        return false;
    }
    if (!url.startsWith(process.env.NEXT_PUBLIC_APP_URL)) {
        return false;
    }
    return true;
}

// HELPERS
export function slugify(word: string): string {
    return word.toLowerCase().trim().replace(/[^\w\s-]/g, '').replace(/[\s_-]+/g, '-').replace(/^-+|-+$/g, '');
}

export function toSnakeCase(string: string) {
    return string.replace(/\W+/g, " ")
        .split(/ |\B(?=[A-Z])/)
        .map(word => word.toLowerCase())
        .join('_');
};

export function makeSlugFromUrlParams(params: string[]) {
    const words = params.map((word) => decodeURIComponent(word));
    // console.log(words.join('/'))
    return words.join("/");
}

export function buildSearchParams(data: any) {
    const params = new URLSearchParams();
    Object.entries(data).forEach(([key, value]) => {
        // DISKUTOVATI ZASTO JE SAMO VALUE
        // PROBLEM ZA VREDNOST 0
        if (value || value === 0) {
            if (Array.isArray(value)) {
                value.forEach(value => params.append(key + '[]', decodeURIComponent(value.toString())));
            } else {
                params.append(key, decodeURIComponent(value.toString()));
            }
        }
    });
    console.log(params);
    return params.toString();
}

export function routeUrlLinkHref(props: {pathname?: string, lang?: string, query?: {[key: string]: any}, multilangslugs?: Record<string,string>, fake_url?: boolean}): {pathname?: string, query?: string} {
    const { lang, pathname, query, multilangslugs, fake_url } = props;
    let path = (multilangslugs && multilangslugs[lang]) ? multilangslugs[lang] : (pathname ? pathname : '');
    //normalize path from /page/[id] to /page/:id to mathc rewrites format
    path = path.replace(/(\[([^\[\]]+)\])/, ':$2');
    //remove trailing slash from path
    path = path.replace(/[\/]+$/, '');
    // console.log('translations: ', routesTranslations, path, routesTranslations.hasOwnProperty(path));
    //try to find route translation
    // if (routesTranslations.hasOwnProperty(path) && lang) {
    //     const routeTranslations = routesTranslations[path];
    //     if (routeTranslations[lang]) {
    //         path = routeTranslations[lang];
    //     }
    // }


    
    //get path slugs transform /page/:param1/test/:param2 into ['page', ':param1', 'test', ':param2']
    const pathSlugs = path.replace(/[\/]+$/, '').replace(/^[\/]+/, '').split('/');

    //process query params
    const queryParams = new URLSearchParams(query);

    for (const queryParamData of queryParams) {
        const [param, value] = queryParamData;

        for (const pathSlugIndex in pathSlugs) {
            const routeParam = ':' + param;

            if (pathSlugs[pathSlugIndex] != routeParam) {
                continue;
            }

            //replace route param with query param value
            pathSlugs[pathSlugIndex] = encodeURIComponent(value);

            //remove param from query 
            queryParams.delete(param);
        }
    }
    
    const linkHref: {pathname: string, query?: string} = {
        pathname: (fake_url ? '/' : '') + pathSlugs.join('/')
            //'/' + (lang && lang !== process.env.NEXT_PUBLIC_DEFAULT_LANG ? lang + '/' : '') + pathSlugs.join('/')
    };

    //there are some more queryParams left, append query string
    if (new Array(queryParams.keys()).length > 0) {
        linkHref.query = queryParams.toString();
    }
    // console.log(linkHref)
    return linkHref;
}

export function routeUrl(props: {pathname?: string, lang?: string, query?: {[key: string]: any}, multilangslugs?: Record<string,string>, fake_url?: boolean}): string {
    // if(typeof window == 'undefined'){
    //     return '';
    // }
    // console.log(props.pathname)
    const linkHref = routeUrlLinkHref(props);
    let url: string = linkHref.pathname;
    if (linkHref.query) {
        url = url + '?' + linkHref.query;
    }
    // console.log('linkHref: ', url)
    
    return url;
}

export function translatePrefix(lang: string, prefix: {en: string, sr: string}){
    return prefix[lang];
}